import { showFormatedDate, showFormattedTime, showFormatedDateandTime } from '../../../../../actions/utilAction';
import classNames from 'classnames';
import { renderTextField, renderCheckBox, renderTimePicker, renderAutoCompleteSingleSelect, renderDateField, renderTextArea } from '../../../../../components/reduxFields';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import { connect } from 'react-redux';
// import PatientInfo from '../../../patient_info';
import React from 'react';
import history from '../../../../../history';
import moment from 'moment';
import SignatureModal from './patient_signature_modal';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import { getPatientSingleEncounter, saveEncounterSigns, savePatientEncounter } from '../actions';
import { getMasterData} from '../../../../scheduling/components/SessionNotes_SOAR/actions/soapActions';


class EncounterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openSign: false,
      appointmentTypeName: '',
      appointmentDate: null,
      appointmentTime: null,
      staffName: '',
      serviceFacility: '',
      isDirectService: false,
      PatientLocationName: '',
      EmployeeSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      appointmentId: props.match.params.apptId,
      encounterId: props.match.params.encId,
      Signee: [],
      patient_id: null,
      staffID: null,      
      timeDifference: 0.0,
      master_data: props.master_data,
    };
  }
  componentWillMount() {
    this.props.getMasterData();
    let searchObj = {
      'apptId': this.state.appointmentId,
      'encounterId': this.state.encounterId,
    };
    this.props.getPatientSingleEncounter(searchObj);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.singleEncounter && nextProps.singleEncounter !== this.props.singleEncounter) {
      let appointmentData = nextProps.singleEncounter.patientAppointment;
      if (appointmentData) {
        let staffIds = [];
        let staffNames = [];
        appointmentData.appointmentSingleStaff.forEach((staff) => {
          staffIds.push(staff.staffId);
          staffNames.push(staff.staffName);
        });
        let staffID = staffIds && staffIds.length ? staffIds[0] : null;
        this.setState({
          appointmentTypeName: appointmentData.appointmentTypeName,
          appointmentDate: showFormatedDate(appointmentData.startDateTime),
          appointmentTime: showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime),
          staffName: staffNames && staffNames ? staffNames.join(',') : '',
          serviceFacility: appointmentData.serviceFacility,
          isDirectService: appointmentData.isDirectService,
          PatientLocationName: appointmentData.address,
          patient_id: appointmentData.patientID,
          staffID: staffID,          
          timeDifference: appointmentData.timeDifference,
        });

        let soapObj = nextProps.singleEncounter;
        let guardianSignObj = {}, clientSignObj = {}, employeeSignObj = {};
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              guardianSignObj = data;
            }
            if (signObj.patientSign) {
              let data = {
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: nextProps.singleEncounter.patientName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              clientSignObj = data;
            }
            if (signObj.clinicianSign) {
              let data = {
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: staffNames && staffNames ? staffNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              employeeSignObj = data;
            }
          });
        }
        let signeeArray = [];
        this.setState({
          ClientSign: clientSignObj,
          GuardianSign: guardianSignObj,
          EmployeeSign: employeeSignObj,
        });
        if (!(clientSignObj && clientSignObj.Bytes)) {
          // signeeArray.push({ id: 1, value: 'Client' });
        }
        if (!(guardianSignObj && guardianSignObj.Bytes)) {
          signeeArray.push({ id: 2, value: 'Guardian' });
        }
        this.setState({ Signee: signeeArray });
      }
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,     
      });
    }

    if (nextProps.dateOfNextSession && this.props.dateOfNextSession !== nextProps.dateOfNextSession) {   
      this.setState({ DateOfNextSession: nextProps.dateOfNextSession});     
    }

  }

  renderDiagnosis() {
    if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    } else {
      if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length !== 0) {
        return this.props.initialValues.diagnosisArray.map((diagnosis, index) => {
          if (diagnosis.IsDeleted) {
            return <tr key={index}><td colSpan='3'><span className='redfont'>{diagnosis.description}</span></td></tr>;
          }
          return (
            <TableRow key={index}>
              <TableRowColumn width="30%">{diagnosis.icdCode}</TableRowColumn>
              <TableRowColumn width="70%">{diagnosis.description ? diagnosis.description : '-'}</TableRowColumn>
              {/* <td width="10%"><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont">Remove</button></td>*/}
            </TableRow>
          );
        });
      }
    }
  }


  renderCpt() {
    if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    } else if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length !== 0) {
      return this.props.initialValues.CPTTableData.map((cpt, index) => {
        if (cpt.IsDeleted) {
          return <tr key={index}><td colSpan='3'><span className='redfont'>{cpt.serviceCode}</span></td></tr>;
        }
        return (
          <TableRow key={index}>
            <TableRowColumn>{cpt.serviceCode ? cpt.serviceCode : '-'}</TableRowColumn>
            <TableRowColumn>{cpt.description ? cpt.description : '-'}</TableRowColumn>
          </TableRow>
        );
      });
    }
  }

  handleBackClick = () => {
    history.push(`/my-appointment/${this.props.singleEncounter.patientID}`);
  };

  handleOpenSign= () => {
    this.setState({ openSign: true });
  };
  handleCloseSign = () => {
    this.setState({ openSign: false });
  };

  handleAddSign = (formProps) => {

    let signBytes = formProps.signBytes.substring(22);
    let data = {
      Bytes: signBytes,
      Date: moment().format('YYYY-MM-DDTHH:mm:ss'),
      Name: '',
    };
    let signeeArray = this.state.Signee;
    switch (formProps.Signee) {
    case 1:
      data.Name = formProps.ClientName;
      this.setState({ ClientSign: data, Signee: signeeArray.splice(0, 1) });
      this.saveEncounterSigns(0, null, data, null);
      break;
    case 2:
      data.Name = formProps.GuardianName;
      this.setState({ GuardianSign: data, Signee: signeeArray.splice(1, 1) });
      this.saveEncounterSigns(0, null, null, data);
      break;
    default:
      break;
    }
  };

  saveEncounterSigns(id = 0, employeeSign, patientSign, guradianSign) {
    let postData = {
      id: id,
      patientEncounterId: this.state.encounterId,
      patientId: patientSign ? this.state.patient_id : null,
      patientSign: patientSign ? patientSign.Bytes : null,
      patientSignDate: patientSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      staffId: employeeSign ? this.state.staffID : null,
      clinicianSign: employeeSign ? employeeSign.Bytes : null,
      clinicianSignDate: employeeSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      guardianName: guradianSign ? guradianSign.Name : null,
      guardianSign: guradianSign ? guradianSign.Bytes : null,
      guardianSignDate: guradianSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
    };
    // console.log(JSON.stringify(postData));
    this.props.saveEncounterSigns(postData);
  }

  render() {
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });

    return (
      <div>
        <h2 className="page_title">Visit Details</h2>
        {/* <PatientInfo patientId={this.state.patientid} /> */}
        <div className="clearfix"></div>
        {this.state.openSign ?
          <SignatureModal Signee={this.state.Signee} clientName={this.props.singleEncounter ? this.props.singleEncounter.patientName : ''} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />
          : null}
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <RaisedButton className="soapmodal_btn mt-20" label="Back" primary={true} onTouchTap={this.handleBackClick} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p className="wd-100">
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      {/* <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p> */}
                      <p>
                        <b>Session Duration (In Mins):</b> <span>{this.state.timeDifference}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    disabled={true}
                    fullWidth={true}
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceEndTime}
                    onDateChange={this.onDateChange}
                    disabled={true}
                    fullWidth={true}
                  />
                </div>
              </div>


              <div className ="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Session Notes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>    
                <div className={'col-sm-12 require'} >                    
                    <Field
                    name="ServiceCoordinatorName"
                    type="text"                   
                    label="Service Coordinator Name"
                    disabled={true}
                    component={renderTextField}                    
                    />
                  </div>   
                                    
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Discipline:</h5><span style={{ color: 'red'}}>*</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="PT"
                    label="PT - 97110"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OT"
                    label="OT - 97530"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ST"
                    label="ST - 92507"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ECE"
                    label="ECE - T1027"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
              </div>              
              <div className="row">
                <div className="col-sm-12">                  
                    <div className="panel_title">
                      <h5>Type Of Service:</h5><span style={{ color: 'red' }}>*</span>
                    </div>                   
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Service"
                    label="Service"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Evaluation"
                    label="Evaluation"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>  
              </div>

              <div className="row">
                <div className="col-sm-12">                  
                    <div className="panel_title">
                      <h5>Participated In Therapy:</h5><span style={{ color: 'red' }}>*</span>
                    </div>                   
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Mom"
                    label="Mom"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GrandParent"
                    label="Grand Parent"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div> 
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Dad"
                    label="Dad"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Caregiver"
                    label="Caregiver"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Siblings"
                    label="Siblings"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>  
              </div>

              <div className="row">
                <div className="col-sm-12">                  
                    <div className="panel_title">
                      <h5>Session Status</h5><span style={{ color: 'red' }}>*</span>
                    </div>                   
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="InitialSession"
                    label="Initial Session"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="LastSession"
                    label="Last Session"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div> 
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="MakeUp"
                    label="Make Up"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProviderCancelled"
                    label="Provider Cancelled"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FamilyCancelled"
                    label="Family Cancelled"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>  
              </div>
              
              
              <div className="row">
                <div className="col-sm-12">
                    <Field
                      name="Goals"
                      type="text"
                      fullWidth={true}
                      label="Outcome(s)/Goal(s) from IFSP/IEP"
                      rowsCount = {6}
                      // autoHeight={true}
                      disabled={true}
                      component={renderTextArea}                      
                    />
                  </div>
                  <div className="col-sm-12">
                    <Field
                      name="ChildOutcomeUpdate"
                      type="text"
                      fullWidth={true}
                      label="Child And Family Outcome Update"
                      rowsCount = {6}
                      // autoHeight={true}
                      disabled={true}
                      component={renderTextArea}                      
                    />
                  </div>
                  <div className="col-sm-12">
                    <Field
                      name="SummaryOfSession"
                      type="text"
                      fullWidth={true}
                      label="Summary Of Session"
                      rowsCount = {6}
                      // autoHeight={true}
                      disabled={true}
                      component={renderTextArea}                      
                    />
                  </div>
              </div>
              <div className="row">
                <div className="col-sm-12">                  
                    <div className="panel_title">
                      <h5>Strategies Used:</h5>
                    </div>                   
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DirectTeaching"
                    label="Direct Teaching"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Demonstration"
                    label="Demonstration"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div> 
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GuidedPractice"
                    label="Guided Practice"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="CaregiverPractice"
                    label="Caregiver Practice"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div> 
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProblemSolving"
                    label="Problem Solving"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Reflection"
                    label="Reflection"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                             
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherStrategiesUsed"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherStrategiesUsed &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherStrategiesUsedNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              <div className="row">
                <div className="col-sm-12">
                    <Field
                      name="ProgressMonitering"
                      type="text"
                      fullWidth={true}
                      label="Progress Monitering"
                      rowsCount = {6}
                      // autoHeight={true}
                      disabled={true}
                      component={renderTextArea}
                      
                    />
                  </div>
                  <div className="col-sm-12">
                    <Field
                      name="PlanForNextSession"
                      type="text"
                      fullWidth={true}
                      label="Plan for next session and opportunites for practice"
                      rowsCount = {6}
                      // autoHeight={true}
                      disabled={true}
                      component={renderTextArea}
                      
                    />
                  </div>
                  <div className="col-sm-12">    
                    <Field
                      name="DateOfNextSession"
                      placeholder="Date Of Next Session"
                      component={renderDateField}
                      locale="en-US"
                      openToYearSelection={true}
                      minDate={new Date()}
                      selected={this.state.DateOfNextSession}
                      onDateChange={this.onDateChange} />
                  </div>
              </div>             
  
              
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Diagnosis</h3>
                    <i className="flaticon flaticon-gym"></i>
                  </div>
                </div>
              </div>
              <div className="mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="20%">Diagnosis Code</TableHeaderColumn>
                      <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderDiagnosis()}
                  </TableBody>
                </Table>
              </div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Service Codes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn>Service Code</TableHeaderColumn>
                      <TableHeaderColumn>Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderCpt()}
                  </TableBody>
                </Table>
              </div>
              {/* {this.props.isSoapRendered && this.state.Signee.length ?
                <div className="row">
                  <div className="col-sm-12 pt20">
                    <RaisedButton className="soapmodal_btn" label="Add Sign" primary={true} onTouchTap={this.handleOpenSign} />
                  </div>
                </div>
                : ''} */}
                {this.state.GuardianSign.Bytes ?
                  '':
                  <div className="row">
                    <div className="col-sm-12 pt20">
                      <RaisedButton className="soapmodal_btn" label="Add Sign"  primary={true} onTouchTap={this.handleOpenSign} />
                    </div>
                  </div>
                }
              { this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes ?
                <div className="row">
                  <div className="col-12">
                    <div className="panel_title mt-24  mb-20">
                      <h3>Signature</h3>
                      <i className="flaticon flaticon-medical-1"></i>
                    </div>
                  </div>
                  {
                    this.state.EmployeeSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageEmployee">

                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                                <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                  {this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                  }
                </div>
                : ''}

            </form>
          </div>
        </div>
      </div>
    );
  }
}
const selector = formValueSelector('EncounterForm');
EncounterForm = reduxForm({
  form: 'EncounterForm',
  enableReinitialize: true,
})(EncounterForm);
function mapStateToProps(state) {
  let initialData = {};
  let appointmentTime = null
    , encounterDetail = state.patientPortal.encounter_detail && state.patientPortal.encounter_detail.data ? state.patientPortal.encounter_detail.data : null;
  // console.log(encounterDetail);
  if (encounterDetail) {
    

    if (encounterDetail.sessionNotes_EBSPA_EarlyIntervention) {
      initialData['Goals'] = encounterDetail.sessionNotes_EBS_Delaware_EI.goals; 
      initialData['ChildOutcomeUpdate'] = encounterDetail.sessionNotes_EBS_Delaware_EI.childOutcomeUpdate; 
      initialData['SummaryOfSession'] = encounterDetail.sessionNotes_EBS_Delaware_EI.summaryOfSession; 
      initialData['ProgressMonitering'] = encounterDetail.sessionNotes_EBS_Delaware_EI.progressMonitering; 
      initialData['PlanForNextSession'] = encounterDetail.sessionNotes_EBS_Delaware_EI.planForNextSession; 
      initialData['ServiceCoordinatorName'] = encounterDetail.sessionNotes_EBS_Delaware_EI.serviceCoordinatorName; 
      initialData['DateOfNextSession'] = encounterDetail.sessionNotes_EBS_Delaware_EI.dateOfNextSession; 

      // ebS_Delaware_EI_Descipline
      initialData['OT'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_Descipline.ot; 
      initialData['PT'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_Descipline.pt; 
      initialData['ST'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_Descipline.st; 
      initialData['ECE'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_Descipline.ece; 
      
      // ebS_Delaware_EI_TypeofService
      initialData['Service'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_TypeofService.service; 
      initialData['Evaluation'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_TypeofService.evaluation; 
      
      // ebS_Delaware_EI_ParticipatedInTherapy
      initialData['Mom'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_ParticipatedInTherapy.mom; 
      initialData['GrandParent'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_ParticipatedInTherapy.grandParent; 
      initialData['Dad'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_ParticipatedInTherapy.dad; 
      initialData['Caregiver'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_ParticipatedInTherapy.caregiver; 
      initialData['Siblings'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_ParticipatedInTherapy.siblings; 
      
      // ebS_Delaware_EI_SessionStatus
      initialData['InitialSession'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_SessionStatus.initialSession; 
      initialData['LastSession'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_SessionStatus.lastSession; 
      initialData['MakeUp'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_SessionStatus.makeUp; 
      initialData['ProviderCancelled'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_SessionStatus.providerCancelled; 
      initialData['FamilyCancelled'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_SessionStatus.familyCancelled; 
      

       // ebS_Delaware_EI_StrategiesUsed
       initialData['DirectTeaching'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.directTeaching; 
       initialData['Demonstration'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.demonstration; 
       initialData['GuidedPractice'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.guidedPractice; 
       initialData['CaregiverPractice'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.caregiverPractice; 
       initialData['ProblemSolving'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.problemSolving; 
       initialData['Reflection'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.reflection; 
       initialData['OtherStrategiesUsed'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.otherStrategiesUsed; 
       initialData['OtherStrategiesUsedNotes'] = encounterDetail.sessionNotes_EBS_Delaware_EI.ebS_Delaware_EI_StrategiesUsed.otherStrategiesUsedNotes; 
       
  }

    if (encounterDetail.patientEncounterDiagnosisCodes) {
      initialData['diagnosisArray'] = encounterDetail.patientEncounterDiagnosisCodes;
    }
    if (encounterDetail.patientEncounterServiceCodes) {
      initialData['CPTTableData'] = encounterDetail.patientEncounterServiceCodes;
    }

    // if(encounterDetail.appointmentStartDateTime){
    //   let startTimehours = encounterDetail.appointmentStartDateTime.substr(11, 2);
    //   let endTimehours = encounterDetail.appointmentEndDateTime.substr(11, 2);
    //   let formattedStartTimehours = parseInt(startTimehours) >= 12 ?
    //     (parseInt(startTimehours) - 12 < 10 ?
    //       `0${parseInt(startTimehours) - 12}`
    //       : startTimehours)
    //     : startTimehours;
    //   let formattedEndTimehours = parseInt(endTimehours) >= 12 ? (parseInt(endTimehours) - 12 < 10 ? `0${parseInt(endTimehours) - 12}` : endTimehours) : endTimehours;
    //   let AmPmOfStartTime = parseInt(startTimehours) >= 12 ? 'pm' : 'am';
    //   let AmPmOfEndTime = parseInt(endTimehours) >= 12 ? 'pm' : 'am';
    //   appointmentTime = `${formattedStartTimehours}:${encounterDetail.appointmentStartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${encounterDetail.appointmentEndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
    //   initialData['appointmentTime'] = appointmentTime;
    // }

    // console.log('encounterDetail.............', encounterDetail);

    if (encounterDetail.startDateTime) {
      let startTimehours = encounterDetail.startDateTime.substr(11, 2);
      let endTimehours = encounterDetail.endDateTime.substr(11, 2);
      let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ? (parseInt(startTimehours, 10) - 12 < 10 ? `0${parseInt(startTimehours, 10) - 12}` : startTimehours) : startTimehours;
      let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;

      let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
      let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
      appointmentTime = `${formattedStartTimehours}:${encounterDetail.startDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${encounterDetail.endDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      initialData['appointmentTime'] = appointmentTime;
    }


    initialData['locationName'] = encounterDetail.locationName;
    initialData['staffName'] = encounterDetail.staffName;
    initialData['appointmentDate'] = encounterDetail.patientAppointment.startDateTime;
    initialData['PatientLocationName'] = encounterDetail.PatientLocationName;
    initialData['serviceEndTime'] = moment(encounterDetail.patientAppointment.endDateTime).format('YYYY-MM-DD') + 'T' + moment(encounterDetail.patientAppointment.endDateTime).format('HH:mm:ss');
    initialData['serviceStartTime'] = moment(encounterDetail.patientAppointment.startDateTime).format('YYYY-MM-DD') + 'T' + moment(encounterDetail.patientAppointment.startDateTime).format('HH:mm:ss');

  }
  let isSoapRendered = false;
  if (encounterDetail && encounterDetail.status && encounterDetail.status.toLowerCase() === 'rendered') {
    isSoapRendered = true;
  }

  return {
    selectorOtherTypeofService: selector(state, 'OtherTypeofService'),
    selectorOtherTypeofSession: selector(state, 'OtherTypeofSession'),
    selectorOtherStrategiesUsed: selector(state, 'OtherStrategiesUsed'),
    singleEncounter: encounterDetail,
    isSoapRendered: isSoapRendered,
    initialValues: initialData,
    master_data: state.soap.master_data,
    dateOfNextSession: initialData && initialData.DateOfNextSession ? initialData.DateOfNextSession : '',
  };
}
export default connect(mapStateToProps, { getPatientSingleEncounter, savePatientEncounter, saveEncounterSigns, getMasterData })(EncounterForm);



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/details/components/patient_sessionnotes_DelawareEI_EBS.js